(function () {
  function fileName(src) {
    return String(src || '').split('?')[0].split('/').pop().toLowerCase();
  }

  function variantMediaIds(product) {
    var ids = {};
    (product.variants || []).forEach(function (v) {
      if (v.featured_media && v.featured_media.id) ids[v.featured_media.id] = true;
      if (v.featured_image && v.featured_image.id) ids['img' + v.featured_image.id] = true;
    });
    return ids;
  }

  function isPrint(media, product, ids) {
    if (!media || (media.media_type && media.media_type !== 'image')) return false;
    ids = ids || variantMediaIds(product);
    if (ids[media.id]) return false;
    var img = media.preview_image || media;
    var name = fileName(img.src || media.src);
    var prefix = name.slice(0, 2);
    return (img.width || 0) >= 1800 || prefix === 's_' || prefix === 's-';
  }

  function visibleMedia(product) {
    var media = product.media || [];
    if (media.length < 2) return media;
    var ids = variantMediaIds(product);
    var kept = media.filter(function (m) { return !isPrint(m, product, ids); });
    return kept.length ? kept : media;
  }

  window.illPrintSkip = { isPrint: isPrint, visibleMedia: visibleMedia };
})();
